import styled from 'styled-components/macro'

import { ColorItem } from './components/ColorItem'
import { Color } from 'features/Orders/Review/components/Overview/components/ProductsWidget/types'

export const ColorsList = ({ colors, testId }: Props) => {
  return (
    <StyledList data-testid={testId}>
      {colors.map((color) => (
        <ColorItem key={color.id} color={color} />
      ))}
    </StyledList>
  )
}

type Props = {
  colors: Color[]
  testId?: string
}

const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  & li:not(:first-child) {
    margin-top: 12px;
  }
`
